var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('PageHeader',{attrs:{"title":_vm.$tc('generic-str.detail', 2)}}),_c('div',{staticClass:"page-content container-fluid"},[_c('sms-properties-card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }